// extracted by mini-css-extract-plugin
export default {"spotify":"Spotify_spotify__JG8jW","listening":"Spotify_listening__mC6MQ","song":"Spotify_song__f8l3l"};